export default __webpack_public_path__ + "static/media/mail.6a45e0d9.svg";